var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDoubleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chevron-double-left_svg__clip0_2046_3043)",
    fill: "#FFC53D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.776 6.427a.598.598 0 010-.848l4.8-4.803a.6.6 0 01.848.848L2.05 5.999l4.378 4.378a.6.6 0 01-.848.848L.776 6.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.576 6.427a.598.598 0 010-.848l4.8-4.803a.6.6 0 01.848.848L6.85 5.999l4.378 4.378a.6.6 0 01-.847.848L5.575 6.427z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chevron-double-left_svg__clip0_2046_3043"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgChevronDoubleLeft;